import errorHandler from '@/utils/errorHandler'

export default {
    methods: {
        errorHandler(error) {
            errorHandler(this, error)
        },
    },
}